/*
 * @Author: PanYunhong
 * @Date: 2022-07-08 13:14:14
 * @LastEditors: ziyongqiang
 * @LastEditTime: 2023-06-08 14:06:11
 */
import { get, post, postRequest, } from '@/request/request';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import { serverIp, fireImgIp, } from '@/configs/index';

// 引入数据
import regionData from '@/configs/allRegion';
import { registerRuntimeCompiler, } from 'vue';

type LineChart = {
  time: string[],
  co2: number[],
  ch4: number[]
};
interface ObjectData {
  [propName: string]: any;
}

// 获取行政区域下级
const getRegionKey = (data:any, id:string) :any => {
  for (let i = 0; i < data.length; i++) {
    let reuslt = [];

    if (data[i].id === id) {
      if (data[i].children) {
        data[i].children.forEach((it:any) => {
          reuslt.push(it.name);
        });
      } else {
        reuslt.push(data[i].name);
      }

      return reuslt;
    }

    if (data[i].children) {
      reuslt = getRegionKey(data[i].children, id);
      if (reuslt) {
        return reuslt;
      }
    }
  }

  return null;
};

// 统计0的数目
const getZeroNum = (data:any) :number => {
  let sum = 0;

  Object.values(data).forEach((item) => {
    if (item === 0) {
      sum += 1;
    }
  });

  return sum;
};

// 碳通量数据处理
const dealCaron = (data:any,regionId:string) => {
  // 最后地区数目统计
  const tempData :ObjectData = {
  };
  const temp = {};
  const tmpTrue = true;

  getRegionKey(regionData, regionId).forEach((item:any) => {
    tempData[item] = [];
  });

  if (data) {
    Object.keys(data).forEach((item) => {
      temp[item] = {};
    });
  }

  Object.keys(temp).forEach((item) => {
    Object.keys(tempData).forEach((i) => {
      temp[item][i] = 0;
    });
  });

  if (data) {
    Object.keys(data).forEach((time) => {
      data[time].forEach((item:any) => {
        temp[time][item.county] = Number(item.consumption);
      });
    });
  }

  tempData.time = [];

  Object.keys(temp).forEach((item) => {
    if (getZeroNum(temp[item]) !== 10) {
      Object.keys(temp[item]).forEach((i) => {
        // eslint-disable-next-line no-unused-expressions
        tempData[i]?.push(temp[item][i]);
      });
      tempData.time.push(item);
    }
  });

  return { carbonFluxNPP: tempData ,carbonFluxTimeNPP: temp, };
};

// 获取绿化面积分布
export const getGreenArea = async () => {
  const data = await postRequest('/carbon/statisticMonitorCompanyByArea');

  return new Promise((resolve, reject) => {
    if (data.code === '200') {
      const temp :any[] = [];

      data.data.forEach((item:any) => {
        temp.push({
          name: item.area,
          value: item.result,
        });
      });

      const tempData = [{
        area: '解放区',
        meadow: 10568000,
        bush: 12871500,
      },
      {
        area: '中站区',
        meadow: 27774800,
        bush: 17698300,
      },
      {
        area: '马村区',
        meadow: 8391700,
        bush: 67977400,
      },
      {
        area: '山阳区',
        tree: 400,
        meadow: 16116300,
        bush: 89364700,
      },
      {
        area: '修武县',
        meadow: 104269400,
        bush: 248321100,
      },
      {
        area: '博爱县',
        tree: 300,
        meadow: 66731900,
        bush: 160354200,
      },
      {
        area: '武陟县',
        meadow: 30691700,
        bush: 557653300,
      },
      {
        area: '温县',
        meadow: 22731400,
        bush: 361672800,
      },
      {
        area: '沁阳市',
        meadow: 46726300,
        bush: 305801100,
      },
      {
        area: '孟州市',
        meadow: 22436100,
        bush: 347983000,
      },];

      tempData.forEach((item:any) => {
        if (item.tree) {
          temp.push({
            name: item.area,
            value: (item.tree + item.meadow + item.bush) / 10000,
          });
        } else {
          temp.push({
            name: item.area,
            value: (item.meadow + item.bush) / 10000,
          });
        }
      });

      resolve(temp);
    } else {
      reject(data.msg);
    }
  });
};

// 获取区域碳排放监测
export const getMonitList = () => postRequest('/carbon/statisticMonitorCompanyByAreaInfo');

// 获取碳排放实时监测
export const getMonitByTime = async () => {
  const data = await postRequest('/carbon/statisticGreenhouseGas');
  // 数据处理
  const tempData :LineChart = {
    time: [],
    co2: [],
    ch4: [],
  };

  return new Promise((resolve, reject) => {
    if (data.code === '200') {
      data.data.forEach((item:any) => {
        if (item.ch4 !== '0' && item.co2 !== '0') {
          tempData.time.push(item.issue);
          tempData.co2.push(item.co2);
          tempData.ch4.push(item.ch4);
        }
      });
      resolve(tempData);
    } else {
      reject(data.msg);
    }
  });
};
// 获取地图json数据
export const getMapJson = (regionId:string) => new Promise((resolve, reject) => {
  const param = regionId.substring(0,6);

  axios.get(`${fireImgIp}/ExternalData/areaFile/${param}.json`).then(({ data, }) => {
    resolve(data);
  });
});
// 获取各区域碳通量估算
export const getCaronData = async (regionId:string,caronType:string) => {
  const params = {
    type: caronType,
    beginTime: moment().startOf('year').format('YYYYMMDD'),
    endTime: moment().format('YYYYMMDD'),
  };
  const data = await postRequest(`/carbon/statisticCarbonFlux`,params);

  return new Promise((resolve, reject) => {
    if (data.code === '200') {
      const { carbonFluxNPP ,carbonFluxTimeNPP, } = dealCaron(data.data,regionId);

      resolve({ carbonFluxNPP,carbonFluxTimeNPP, });
    } else {
      reject(data.msg);
    }
  });
};
